module.exports = {
	"config": {
		"siteTitle": "Textkrieg",
		"siteDescr": "awkwardness as a service",
		"siteAuthor": "Ada Blitz",
		"siteTwitterUrl": "https://twitter.com/bangpowwww",
		"siteEmailUrl": "mail-to:kontakt@textkrieg.de",
		"googleAnalyticsId": "",
		"linkPrefix": "/gatsby-starter-lumen"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "10-dinge-die-man-bei-grippe-tun-kann",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "10-dinge-die-man-bei-grippe-tun-kann",
				"stem": "index",
				"path": "10-dinge-die-man-bei-grippe-tun-kann/index.md"
			},
			"requirePath": "10-dinge-die-man-bei-grippe-tun-kann/index.md",
			"path": "/10-dinge-die-man-bei-grippe-tun-kann/",
			"data": {
				"title": "10 Dinge, die man bei Grippe tun kann",
				"date": "2015-03-04 15:12:53 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "10-erkenntnisse-uber-frankreich",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "10-erkenntnisse-uber-frankreich",
				"stem": "index",
				"path": "10-erkenntnisse-uber-frankreich/index.md"
			},
			"requirePath": "10-erkenntnisse-uber-frankreich/index.md",
			"path": "/10-erkenntnisse-uber-frankreich/",
			"data": {
				"title": "10 Erkenntnisse über Frankreich",
				"date": "2014-09-15 13:53:40 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "10-grnde-warum-berlin-out-ist-",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "10-grnde-warum-berlin-out-ist-",
				"stem": "index",
				"path": "10-grnde-warum-berlin-out-ist-/index.md"
			},
			"requirePath": "10-grnde-warum-berlin-out-ist-/index.md",
			"path": "/10-grnde-warum-berlin-out-ist-/",
			"data": {
				"title": "10 Gründe warum Berlin out ist:",
				"date": "2014-02-27 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "99fire-films-award",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "99fire-films-award",
				"stem": "index",
				"path": "99fire-films-award/index.md"
			},
			"requirePath": "99fire-films-award/index.md",
			"path": "/99fire-films-award/",
			"data": {
				"title": "Der 99Fire-Films Award",
				"date": "2012-02-17 11:33:45 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ada-and-her-dream-of-horses",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ada-and-her-dream-of-horses",
				"stem": "index",
				"path": "ada-and-her-dream-of-horses/index.md"
			},
			"requirePath": "ada-and-her-dream-of-horses/index.md",
			"path": "/ada-and-her-dream-of-horses/",
			"data": {
				"title": "Ada and her dream of horses",
				"date": "2011-07-19 09:23:12 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ada-blitzkrieg-das-hoerbuch",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ada-blitzkrieg-das-hoerbuch",
				"stem": "index",
				"path": "ada-blitzkrieg-das-hoerbuch/index.md"
			},
			"requirePath": "ada-blitzkrieg-das-hoerbuch/index.md",
			"path": "/ada-blitzkrieg-das-hoerbuch/",
			"data": {
				"title": "Ada Blitzkrieg - Das Hörbuch",
				"date": "2011-12-01 18:12:43 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ada-blitzkrieg-guckt-alles",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ada-blitzkrieg-guckt-alles",
				"stem": "index",
				"path": "ada-blitzkrieg-guckt-alles/index.md"
			},
			"requirePath": "ada-blitzkrieg-guckt-alles/index.md",
			"path": "/ada-blitzkrieg-guckt-alles/",
			"data": {
				"title": "Ada Blitzkrieg guckt alles",
				"date": "2012-02-26 18:45:06 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "alles-gute-zum-geburtstag-ada",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "alles-gute-zum-geburtstag-ada",
				"stem": "index",
				"path": "alles-gute-zum-geburtstag-ada/index.md"
			},
			"requirePath": "alles-gute-zum-geburtstag-ada/index.md",
			"path": "/alles-gute-zum-geburtstag-ada/",
			"data": {
				"title": "Alles Gute zum Geburtstag Ada!",
				"date": "2011-08-11 13:13:42 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "als-ich-ein-pony-zu-weihnachten-bekam",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "als-ich-ein-pony-zu-weihnachten-bekam",
				"stem": "index",
				"path": "als-ich-ein-pony-zu-weihnachten-bekam/index.md"
			},
			"requirePath": "als-ich-ein-pony-zu-weihnachten-bekam/index.md",
			"path": "/als-ich-ein-pony-zu-weihnachten-bekam/",
			"data": {
				"title": "Als ich ein Pony zu Weihnachten bekam",
				"date": "2012-01-02 13:17:45 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "apartment-hunting-san-francisco",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "apartment-hunting-san-francisco",
				"stem": "index",
				"path": "apartment-hunting-san-francisco/index.md"
			},
			"requirePath": "apartment-hunting-san-francisco/index.md",
			"path": "/apartment-hunting-san-francisco/",
			"data": {
				"title": "Apartment hunting San Francisco",
				"date": "2014-04-23 16:14:03 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "archive-post",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "archive-post",
				"stem": "index",
				"path": "archive-post/index.md"
			},
			"requirePath": "archive-post/index.md",
			"path": "/archive-post/",
			"data": {
				"title": "archive",
				"date": "2012-12-17 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles",
				"stem": "index",
				"path": "articles/index.md"
			},
			"requirePath": "articles/index.md",
			"path": "/articles/",
			"data": {
				"title": "Articles",
				"date": "2011-03-22 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "audiokrieg-gesammelte-werke-mit-sprachfehler",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "audiokrieg-gesammelte-werke-mit-sprachfehler",
				"stem": "index",
				"path": "audiokrieg-gesammelte-werke-mit-sprachfehler/index.md"
			},
			"requirePath": "audiokrieg-gesammelte-werke-mit-sprachfehler/index.md",
			"path": "/audiokrieg-gesammelte-werke-mit-sprachfehler/",
			"data": {
				"title": "Audiokrieg - Gesammelte Werke mit Sprachfehler",
				"date": "2012-06-06 15:27:45 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "awesome-places-grandmother",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "awesome-places-grandmother",
				"stem": "index",
				"path": "awesome-places-grandmother/index.md"
			},
			"requirePath": "awesome-places-grandmother/index.md",
			"path": "/awesome-places-grandmother/",
			"data": {
				"title": "Awesome Places: Grandmother",
				"date": "2011-11-07 13:07:37 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "balkankrieg-vs-textkrieg",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "balkankrieg-vs-textkrieg",
				"stem": "index",
				"path": "balkankrieg-vs-textkrieg/index.md"
			},
			"requirePath": "balkankrieg-vs-textkrieg/index.md",
			"path": "/balkankrieg-vs-textkrieg/",
			"data": {
				"title": "Balkankrieg vs. Textkrieg",
				"date": "2011-06-27 16:58:41 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten",
				"stem": "index",
				"path": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten/index.md"
			},
			"requirePath": "barbara-scheel-anne-will-und-rassismus-bei-den-piraten/index.md",
			"path": "/barbara-scheel-anne-will-und-rassismus-bei-den-piraten/",
			"data": {
				"title": "Barbara Scheel, Anne Will und Rassismus bei den Piraten",
				"date": "2012-03-29 13:49:02 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "batik-3000",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "batik-3000",
				"stem": "index",
				"path": "batik-3000/index.md"
			},
			"requirePath": "batik-3000/index.md",
			"path": "/batik-3000/",
			"data": {
				"title": "Batik3000",
				"date": "2011-06-09 08:54:13 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "batiken-statt-club",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "batiken-statt-club",
				"stem": "index",
				"path": "batiken-statt-club/index.md"
			},
			"requirePath": "batiken-statt-club/index.md",
			"path": "/batiken-statt-club/",
			"data": {
				"title": "Batiken statt Club",
				"date": "2011-06-06 16:25:25 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "baut-mal-was",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "baut-mal-was",
				"stem": "index",
				"path": "baut-mal-was/index.md"
			},
			"requirePath": "baut-mal-was/index.md",
			"path": "/baut-mal-was/",
			"data": {
				"title": "Baut mal was!",
				"date": "2014-06-17 17:29:17 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "berlin-festival-2011",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "berlin-festival-2011",
				"stem": "index",
				"path": "berlin-festival-2011/index.md"
			},
			"requirePath": "berlin-festival-2011/index.md",
			"path": "/berlin-festival-2011/",
			"data": {
				"title": "Berlin Festival 2011",
				"date": "2011-09-12 14:56:52 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "berlins-bestes-franzbrotchen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "berlins-bestes-franzbrotchen",
				"stem": "index",
				"path": "berlins-bestes-franzbrotchen/index.md"
			},
			"requirePath": "berlins-bestes-franzbrotchen/index.md",
			"path": "/berlins-bestes-franzbrotchen/",
			"data": {
				"title": "Berlins bestes Franzbrötchen",
				"date": "2016-02-25 12:20:39 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "beschauliches-berlin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "beschauliches-berlin",
				"stem": "index",
				"path": "beschauliches-berlin/index.md"
			},
			"requirePath": "beschauliches-berlin/index.md",
			"path": "/beschauliches-berlin/",
			"data": {
				"title": "Beschauliches Berlin",
				"date": "2011-10-10 14:47:18 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "best-of-republica-2015",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "best-of-republica-2015",
				"stem": "index",
				"path": "best-of-republica-2015/index.md"
			},
			"requirePath": "best-of-republica-2015/index.md",
			"path": "/best-of-republica-2015/",
			"data": {
				"title": "Best of re:publica 2015",
				"date": "2015-05-08 15:51:49 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "bildung-gegen-langeweile",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "bildung-gegen-langeweile",
				"stem": "index",
				"path": "bildung-gegen-langeweile/index.md"
			},
			"requirePath": "bildung-gegen-langeweile/index.md",
			"path": "/bildung-gegen-langeweile/",
			"data": {
				"title": "Bildung gegen Langeweile",
				"date": "2012-11-01 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blitzkrieg-lesen-den-vierten-affen-bestellen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blitzkrieg-lesen-den-vierten-affen-bestellen",
				"stem": "index",
				"path": "blitzkrieg-lesen-den-vierten-affen-bestellen/index.md"
			},
			"requirePath": "blitzkrieg-lesen-den-vierten-affen-bestellen/index.md",
			"path": "/blitzkrieg-lesen-den-vierten-affen-bestellen/",
			"data": {
				"title": "Blitzkrieg lesen? Den vierten Affen bestellen!",
				"date": "2014-05-08 13:23:02 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blutgrtsche-in-die-homophobie",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blutgrtsche-in-die-homophobie",
				"stem": "index",
				"path": "blutgrtsche-in-die-homophobie/index.md"
			},
			"requirePath": "blutgrtsche-in-die-homophobie/index.md",
			"path": "/blutgrtsche-in-die-homophobie/",
			"data": {
				"title": "Blutgrätsche in die Homophobie",
				"date": "2013-04-02 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "books",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "books",
				"stem": "index",
				"path": "books/index.md"
			},
			"requirePath": "books/index.md",
			"path": "/books/",
			"data": {
				"title": "Romane von Ada Blitzkrieg",
				"date": "2014-07-24 12:30:31 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "born-in-1985",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "born-in-1985",
				"stem": "index",
				"path": "born-in-1985/index.md"
			},
			"requirePath": "born-in-1985/index.md",
			"path": "/born-in-1985/",
			"data": {
				"title": "Born in 1985",
				"date": "2014-08-22 09:33:50 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "brotaufstrich-hiroshima",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "brotaufstrich-hiroshima",
				"stem": "index",
				"path": "brotaufstrich-hiroshima/index.md"
			},
			"requirePath": "brotaufstrich-hiroshima/index.md",
			"path": "/brotaufstrich-hiroshima/",
			"data": {
				"title": "Brotaufstrich Hiroshima",
				"date": "2011-09-03 13:23:18 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "california-reisestimmung-mit-instagram-surfprints",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "california-reisestimmung-mit-instagram-surfprints",
				"stem": "index",
				"path": "california-reisestimmung-mit-instagram-surfprints/index.md"
			},
			"requirePath": "california-reisestimmung-mit-instagram-surfprints/index.md",
			"path": "/california-reisestimmung-mit-instagram-surfprints/",
			"data": {
				"title": "California Reisestimmung mit Instagram Surfprints",
				"date": "2014-04-28 09:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "cats-dogs-and-cake",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "cats-dogs-and-cake",
				"stem": "index",
				"path": "cats-dogs-and-cake/index.md"
			},
			"requirePath": "cats-dogs-and-cake/index.md",
			"path": "/cats-dogs-and-cake/",
			"data": {
				"title": "Cats, dogs and cake",
				"date": "2012-08-14 14:43:27 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "chaos-communication-camp-2011-erster-teil",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "chaos-communication-camp-2011-erster-teil",
				"stem": "index",
				"path": "chaos-communication-camp-2011-erster-teil/index.md"
			},
			"requirePath": "chaos-communication-camp-2011-erster-teil/index.md",
			"path": "/chaos-communication-camp-2011-erster-teil/",
			"data": {
				"title": "Chaos Communication Camp 2011 - Erster Teil",
				"date": "2011-08-12 11:40:15 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "christmas-mixtape-nock-nock-eggnog",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "christmas-mixtape-nock-nock-eggnog",
				"stem": "index",
				"path": "christmas-mixtape-nock-nock-eggnog/index.md"
			},
			"requirePath": "christmas-mixtape-nock-nock-eggnog/index.md",
			"path": "/christmas-mixtape-nock-nock-eggnog/",
			"data": {
				"title": "Christmas Mixtape: Nock Nock Eggnog",
				"date": "2013-12-21 13:21:32 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "contact",
				"stem": "index",
				"path": "contact/index.md"
			},
			"requirePath": "contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "KONTAKT",
				"date": "2011-04-11 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "content/images",
				"base": "README.md",
				"ext": "md",
				"name": "README",
				"extname": ".md",
				"basename": "README.md",
				"dirname": "content/images",
				"stem": "README",
				"path": "content/images/README.md"
			},
			"requirePath": "content/images/README.md",
			"path": "/content/images/README/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "dackelkrieg---ein-roman-von-ada-blitzkrieg",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "dackelkrieg---ein-roman-von-ada-blitzkrieg",
				"stem": "index",
				"path": "dackelkrieg---ein-roman-von-ada-blitzkrieg/index.md"
			},
			"requirePath": "dackelkrieg---ein-roman-von-ada-blitzkrieg/index.md",
			"path": "/dackelkrieg---ein-roman-von-ada-blitzkrieg/",
			"data": {
				"title": "DACKELKRIEG - ein Roman von Ada Blitzkrieg",
				"date": "2012-12-15 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dackelkrieg---hrbuch-und-bekenntnisse",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "dackelkrieg---hrbuch-und-bekenntnisse",
				"stem": "index",
				"path": "dackelkrieg---hrbuch-und-bekenntnisse/index.md"
			},
			"requirePath": "dackelkrieg---hrbuch-und-bekenntnisse/index.md",
			"path": "/dackelkrieg---hrbuch-und-bekenntnisse/",
			"data": {
				"title": "Dackelkrieg - Hörbuch und Bekenntnisse",
				"date": "2013-05-28 08:27:59 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dackelkrieg",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "dackelkrieg",
				"stem": "index",
				"path": "dackelkrieg/index.md"
			},
			"requirePath": "dackelkrieg/index.md",
			"path": "/dackelkrieg/",
			"data": {
				"title": "DACKELKRIEG - Ein Roman von Ada Blitzkrieg",
				"date": "2012-12-15 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "darf-man-als-moslem-schinkenchips-essen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "darf-man-als-moslem-schinkenchips-essen",
				"stem": "index",
				"path": "darf-man-als-moslem-schinkenchips-essen/index.md"
			},
			"requirePath": "darf-man-als-moslem-schinkenchips-essen/index.md",
			"path": "/darf-man-als-moslem-schinkenchips-essen/",
			"data": {
				"title": "Darf man als Moslem Schinkenchips essen?",
				"date": "2012-12-09 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "das-ding-mit-den-dobermannvideos",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "das-ding-mit-den-dobermannvideos",
				"stem": "index",
				"path": "das-ding-mit-den-dobermannvideos/index.md"
			},
			"requirePath": "das-ding-mit-den-dobermannvideos/index.md",
			"path": "/das-ding-mit-den-dobermannvideos/",
			"data": {
				"title": "Das Ding mit den Dobermannvideos",
				"date": "2012-05-08 14:27:33 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "das-ding-mit-den-passfotos-ist-ja-so-",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "das-ding-mit-den-passfotos-ist-ja-so-",
				"stem": "index",
				"path": "das-ding-mit-den-passfotos-ist-ja-so-/index.md"
			},
			"requirePath": "das-ding-mit-den-passfotos-ist-ja-so-/index.md",
			"path": "/das-ding-mit-den-passfotos-ist-ja-so-/",
			"data": {
				"title": "Das Ding mit den Passfotos ist ja so:",
				"date": "2012-12-03 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "das-ding-mit-dobermannern-ist-ja-so",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "das-ding-mit-dobermannern-ist-ja-so",
				"stem": "index",
				"path": "das-ding-mit-dobermannern-ist-ja-so/index.md"
			},
			"requirePath": "das-ding-mit-dobermannern-ist-ja-so/index.md",
			"path": "/das-ding-mit-dobermannern-ist-ja-so/",
			"data": {
				"title": "Das Ding mit Dobermännern ist ja so:",
				"date": "2012-05-08 15:29:02 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "das-ding-mit-kurzhaarfrisuren-ist-ja-so",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "das-ding-mit-kurzhaarfrisuren-ist-ja-so",
				"stem": "index",
				"path": "das-ding-mit-kurzhaarfrisuren-ist-ja-so/index.md"
			},
			"requirePath": "das-ding-mit-kurzhaarfrisuren-ist-ja-so/index.md",
			"path": "/das-ding-mit-kurzhaarfrisuren-ist-ja-so/",
			"data": {
				"title": "Das Ding mit Kurzhaarfrisuren ist ja so:",
				"date": "2012-05-31 13:40:37 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "das-kuchenvoting",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "das-kuchenvoting",
				"stem": "index",
				"path": "das-kuchenvoting/index.md"
			},
			"requirePath": "das-kuchenvoting/index.md",
			"path": "/das-kuchenvoting/",
			"data": {
				"title": "Das Kuchenvoting",
				"date": "2011-11-21 16:13:46 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "der-blitz-geht-nach-san-francisco",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "der-blitz-geht-nach-san-francisco",
				"stem": "index",
				"path": "der-blitz-geht-nach-san-francisco/index.md"
			},
			"requirePath": "der-blitz-geht-nach-san-francisco/index.md",
			"path": "/der-blitz-geht-nach-san-francisco/",
			"data": {
				"title": "Der Blitz geht nach San Francisco",
				"date": "2014-04-16 16:42:15 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "der-plural-von-poster-lautet-nicht-posters",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "der-plural-von-poster-lautet-nicht-posters",
				"stem": "index",
				"path": "der-plural-von-poster-lautet-nicht-posters/index.md"
			},
			"requirePath": "der-plural-von-poster-lautet-nicht-posters/index.md",
			"path": "/der-plural-von-poster-lautet-nicht-posters/",
			"data": {
				"title": "Der Plural von Poster lautet nicht Posters",
				"date": "2012-05-22 14:58:50 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "deutsche-und-humor-wetten-dass",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "deutsche-und-humor-wetten-dass",
				"stem": "index",
				"path": "deutsche-und-humor-wetten-dass/index.md"
			},
			"requirePath": "deutsche-und-humor-wetten-dass/index.md",
			"path": "/deutsche-und-humor-wetten-dass/",
			"data": {
				"title": "Deutsche und Humor - Wetten, dass..?",
				"date": "2014-10-30 17:50:15 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-90er-megaparty-oder-wege-in-die-misanthropie",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-90er-megaparty-oder-wege-in-die-misanthropie",
				"stem": "index",
				"path": "die-90er-megaparty-oder-wege-in-die-misanthropie/index.md"
			},
			"requirePath": "die-90er-megaparty-oder-wege-in-die-misanthropie/index.md",
			"path": "/die-90er-megaparty-oder-wege-in-die-misanthropie/",
			"data": {
				"title": "Die 90er Megaparty oder Wege in die Misanthropie",
				"date": "2011-10-16 14:54:54 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-ada-blitzkrieg-homestory-ii",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-ada-blitzkrieg-homestory-ii",
				"stem": "index",
				"path": "die-ada-blitzkrieg-homestory-ii/index.md"
			},
			"requirePath": "die-ada-blitzkrieg-homestory-ii/index.md",
			"path": "/die-ada-blitzkrieg-homestory-ii/",
			"data": {
				"title": "Die Ada Blitzkrieg Homestory II",
				"date": "2013-04-23 16:06:11 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-blitzkrieg-filmographie",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-blitzkrieg-filmographie",
				"stem": "index",
				"path": "die-blitzkrieg-filmographie/index.md"
			},
			"requirePath": "die-blitzkrieg-filmographie/index.md",
			"path": "/die-blitzkrieg-filmographie/",
			"data": {
				"title": "Die Blitzkrieg Filmographie",
				"date": "2015-02-16 16:34:36 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-durum-depression",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-durum-depression",
				"stem": "index",
				"path": "die-durum-depression/index.md"
			},
			"requirePath": "die-durum-depression/index.md",
			"path": "/die-durum-depression/",
			"data": {
				"title": "Die Dürüm Depression",
				"date": "2014-08-05 14:43:44 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin",
				"stem": "index",
				"path": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin/index.md"
			},
			"requirePath": "die-illusion-einer-uberflussgesellschaft-containern-in-berlin/index.md",
			"path": "/die-illusion-einer-uberflussgesellschaft-containern-in-berlin/",
			"data": {
				"title": "Die Illusion einer Überflussgesellschaft - Containern in Berlin",
				"date": "2012-04-20 15:18:44 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-naziheimat-mochte-keine-moschee",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-naziheimat-mochte-keine-moschee",
				"stem": "index",
				"path": "die-naziheimat-mochte-keine-moschee/index.md"
			},
			"requirePath": "die-naziheimat-mochte-keine-moschee/index.md",
			"path": "/die-naziheimat-mochte-keine-moschee/",
			"data": {
				"title": "Die Naziheimat möchte keine Moschee",
				"date": "2014-10-17 17:10:40 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-strenge",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-strenge",
				"stem": "index",
				"path": "die-strenge/index.md"
			},
			"requirePath": "die-strenge/index.md",
			"path": "/die-strenge/",
			"data": {
				"title": "DIE STRENGE - Ein Leseheft von Ada Blitzkrieg",
				"date": "2014-07-24 11:23:02 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "die-zukunft-der-printmedien",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "die-zukunft-der-printmedien",
				"stem": "index",
				"path": "die-zukunft-der-printmedien/index.md"
			},
			"requirePath": "die-zukunft-der-printmedien/index.md",
			"path": "/die-zukunft-der-printmedien/",
			"data": {
				"title": "Die Zukunft der Printmedien",
				"date": "2013-03-03 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dienstleister-die-auf-dich-scheieen-dhl",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "dienstleister-die-auf-dich-scheieen-dhl",
				"stem": "index",
				"path": "dienstleister-die-auf-dich-scheieen-dhl/index.md"
			},
			"requirePath": "dienstleister-die-auf-dich-scheieen-dhl/index.md",
			"path": "/dienstleister-die-auf-dich-scheieen-dhl/",
			"data": {
				"title": "Dienstleister, die auf Dich scheißen: DHL",
				"date": "2011-11-16 13:01:17 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "diy-cookies",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "diy-cookies",
				"stem": "index",
				"path": "diy-cookies/index.md"
			},
			"requirePath": "diy-cookies/index.md",
			"path": "/diy-cookies/",
			"data": {
				"title": "DIY Cookies",
				"date": "2012-08-06 14:53:52 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ein-sonntag-auf-dem-dachshundrennen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ein-sonntag-auf-dem-dachshundrennen",
				"stem": "index",
				"path": "ein-sonntag-auf-dem-dachshundrennen/index.md"
			},
			"requirePath": "ein-sonntag-auf-dem-dachshundrennen/index.md",
			"path": "/ein-sonntag-auf-dem-dachshundrennen/",
			"data": {
				"title": "Ein Sonntag beim Dachshundrennen",
				"date": "2011-09-07 15:30:58 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "eine-bestandsaufnahme",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "eine-bestandsaufnahme",
				"stem": "index",
				"path": "eine-bestandsaufnahme/index.md"
			},
			"requirePath": "eine-bestandsaufnahme/index.md",
			"path": "/eine-bestandsaufnahme/",
			"data": {
				"title": "Die späten 90er und das Millenium - eine Bestandsaufnahme",
				"date": "2011-12-06 16:15:51 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "endstation-weisensee",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "endstation-weisensee",
				"stem": "index",
				"path": "endstation-weisensee/index.md"
			},
			"requirePath": "endstation-weisensee/index.md",
			"path": "/endstation-weisensee/",
			"data": {
				"title": "Endstation Weißensee",
				"date": "2011-06-03 08:55:49 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte",
				"stem": "index",
				"path": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte/index.md"
			},
			"requirePath": "erfolgreiche-frauen-im-internet---keine-liebesgeschichte/index.md",
			"path": "/erfolgreiche-frauen-im-internet---keine-liebesgeschichte/",
			"data": {
				"title": "Erfolgreiche Frauen im Internet - keine Liebesgeschichte",
				"date": "2013-06-10 18:30:15 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "erfolgreiche-frauen-und-das-impostor-syndrom",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "erfolgreiche-frauen-und-das-impostor-syndrom",
				"stem": "index",
				"path": "erfolgreiche-frauen-und-das-impostor-syndrom/index.md"
			},
			"requirePath": "erfolgreiche-frauen-und-das-impostor-syndrom/index.md",
			"path": "/erfolgreiche-frauen-und-das-impostor-syndrom/",
			"data": {
				"title": "Erfolgreiche Frauen und das Impostor Syndrom",
				"date": "2016-03-31 11:04:14 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "eure-meinung-zu-adhs-interessiert-mich-nicht",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "eure-meinung-zu-adhs-interessiert-mich-nicht",
				"stem": "index",
				"path": "eure-meinung-zu-adhs-interessiert-mich-nicht/index.md"
			},
			"requirePath": "eure-meinung-zu-adhs-interessiert-mich-nicht/index.md",
			"path": "/eure-meinung-zu-adhs-interessiert-mich-nicht/",
			"data": {
				"title": "Eure Meinung zu ADHS interessiert mich nicht",
				"date": "2014-02-06 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "exciting-autumn",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "exciting-autumn",
				"stem": "index",
				"path": "exciting-autumn/index.md"
			},
			"requirePath": "exciting-autumn/index.md",
			"path": "/exciting-autumn/",
			"data": {
				"title": "Exciting Autumn",
				"date": "2012-10-30 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fashion-entry-mein-lieblingsshirt",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fashion-entry-mein-lieblingsshirt",
				"stem": "index",
				"path": "fashion-entry-mein-lieblingsshirt/index.md"
			},
			"requirePath": "fashion-entry-mein-lieblingsshirt/index.md",
			"path": "/fashion-entry-mein-lieblingsshirt/",
			"data": {
				"title": "Fashion Entry: Mein Lieblingsshirt",
				"date": "2015-01-21 15:12:50 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fatshaming-in-san-francisco-und-berlin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fatshaming-in-san-francisco-und-berlin",
				"stem": "index",
				"path": "fatshaming-in-san-francisco-und-berlin/index.md"
			},
			"requirePath": "fatshaming-in-san-francisco-und-berlin/index.md",
			"path": "/fatshaming-in-san-francisco-und-berlin/",
			"data": {
				"title": "Fatshaming in San Francisco und Berlin",
				"date": "2014-11-14 21:05:51 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fernsehprogramm",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fernsehprogramm",
				"stem": "index",
				"path": "fernsehprogramm/index.md"
			},
			"requirePath": "fernsehprogramm/index.md",
			"path": "/fernsehprogramm/",
			"data": {
				"title": "Bestimmt mein Fernsehprogramm für einen schlechten Zweck!",
				"date": "2012-02-14 13:21:49 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fischinstallationen-im-offentlichen-raum",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fischinstallationen-im-offentlichen-raum",
				"stem": "index",
				"path": "fischinstallationen-im-offentlichen-raum/index.md"
			},
			"requirePath": "fischinstallationen-im-offentlichen-raum/index.md",
			"path": "/fischinstallationen-im-offentlichen-raum/",
			"data": {
				"title": "Fischinstallationen im öffentlichen Raum",
				"date": "2012-04-02 13:11:23 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "food-truck-your-life",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "food-truck-your-life",
				"stem": "index",
				"path": "food-truck-your-life/index.md"
			},
			"requirePath": "food-truck-your-life/index.md",
			"path": "/food-truck-your-life/",
			"data": {
				"title": "Food Truck Your Life!",
				"date": "2014-03-27 14:34:01 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "freelance",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "freelance",
				"stem": "index",
				"path": "freelance/index.md"
			},
			"requirePath": "freelance/index.md",
			"path": "/freelance/",
			"data": {
				"title": "FREELANCE",
				"date": "2014-02-25T00:00:00.000+00:00",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "furnished-apartment-in-berlin-kreuzberg-for-18-months",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "furnished-apartment-in-berlin-kreuzberg-for-18-months",
				"stem": "index",
				"path": "furnished-apartment-in-berlin-kreuzberg-for-18-months/index.md"
			},
			"requirePath": "furnished-apartment-in-berlin-kreuzberg-for-18-months/index.md",
			"path": "/furnished-apartment-in-berlin-kreuzberg-for-18-months/",
			"data": {
				"title": "Furnished apartment in Berlin Kreuzberg for 18 months",
				"date": "2014-04-30 14:42:56 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fusion-festival-2011",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fusion-festival-2011",
				"stem": "index",
				"path": "fusion-festival-2011/index.md"
			},
			"requirePath": "fusion-festival-2011/index.md",
			"path": "/fusion-festival-2011/",
			"data": {
				"title": "Fusion Festival 2011",
				"date": "2011-07-04 07:57:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "gallery",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "gallery",
				"stem": "index",
				"path": "gallery/index.md"
			},
			"requirePath": "gallery/index.md",
			"path": "/gallery/",
			"data": {
				"title": "Gallery",
				"date": "2012-12-02 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "german-food-vs-amerikanisches-essen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "german-food-vs-amerikanisches-essen",
				"stem": "index",
				"path": "german-food-vs-amerikanisches-essen/index.md"
			},
			"requirePath": "german-food-vs-amerikanisches-essen/index.md",
			"path": "/german-food-vs-amerikanisches-essen/",
			"data": {
				"title": "German Food vs. amerikanisches Essen",
				"date": "2014-04-03 15:10:32 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "gewinner-des-pferdefunpakets",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "gewinner-des-pferdefunpakets",
				"stem": "index",
				"path": "gewinner-des-pferdefunpakets/index.md"
			},
			"requirePath": "gewinner-des-pferdefunpakets/index.md",
			"path": "/gewinner-des-pferdefunpakets/",
			"data": {
				"title": "Gewinner des Pferdefunpakets",
				"date": "2011-08-01 13:35:37 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "gewinnspiel-mit-pferde-merchandise",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "gewinnspiel-mit-pferde-merchandise",
				"stem": "index",
				"path": "gewinnspiel-mit-pferde-merchandise/index.md"
			},
			"requirePath": "gewinnspiel-mit-pferde-merchandise/index.md",
			"path": "/gewinnspiel-mit-pferde-merchandise/",
			"data": {
				"title": "Gewinnspiel mit Pferde-Merchandise",
				"date": "2011-07-09 13:05:42 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "girls-who-release",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "girls-who-release",
				"stem": "index",
				"path": "girls-who-release/index.md"
			},
			"requirePath": "girls-who-release/index.md",
			"path": "/girls-who-release/",
			"data": {
				"title": "Girls who release",
				"date": "2015-10-05 09:09:33 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "google-analytics-bewaffnete-affen-und-katzen-mit-busen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "google-analytics-bewaffnete-affen-und-katzen-mit-busen",
				"stem": "index",
				"path": "google-analytics-bewaffnete-affen-und-katzen-mit-busen/index.md"
			},
			"requirePath": "google-analytics-bewaffnete-affen-und-katzen-mit-busen/index.md",
			"path": "/google-analytics-bewaffnete-affen-und-katzen-mit-busen/",
			"data": {
				"title": "Google Analytics - Bewaffnete Affen und Katzen mit Busen",
				"date": "2012-06-11 14:02:22 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "googledogs-is-my-startup",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "googledogs-is-my-startup",
				"stem": "index",
				"path": "googledogs-is-my-startup/index.md"
			},
			"requirePath": "googledogs-is-my-startup/index.md",
			"path": "/googledogs-is-my-startup/",
			"data": {
				"title": "Googledogs is my startup",
				"date": "2012-06-20 09:52:42 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "guide-ekelhaftes-berlin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "guide-ekelhaftes-berlin",
				"stem": "index",
				"path": "guide-ekelhaftes-berlin/index.md"
			},
			"requirePath": "guide-ekelhaftes-berlin/index.md",
			"path": "/guide-ekelhaftes-berlin/",
			"data": {
				"title": "Guide: Ekelhaftes Berlin",
				"date": "2014-08-13 16:21:54 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "guide-how-to-bath-a-cat",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "guide-how-to-bath-a-cat",
				"stem": "index",
				"path": "guide-how-to-bath-a-cat/index.md"
			},
			"requirePath": "guide-how-to-bath-a-cat/index.md",
			"path": "/guide-how-to-bath-a-cat/",
			"data": {
				"title": "Guide: How to bathe a cat",
				"date": "2014-03-25 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "guide-to-dublin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "guide-to-dublin",
				"stem": "index",
				"path": "guide-to-dublin/index.md"
			},
			"requirePath": "guide-to-dublin/index.md",
			"path": "/guide-to-dublin/",
			"data": {
				"title": "Guide to Dublin",
				"date": "2015-04-01 16:54:29 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "happiness-eine-dystopie",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "happiness-eine-dystopie",
				"stem": "index",
				"path": "happiness-eine-dystopie/index.md"
			},
			"requirePath": "happiness-eine-dystopie/index.md",
			"path": "/happiness-eine-dystopie/",
			"data": {
				"title": "Happiness - eine Dystopie",
				"date": "2012-02-23 11:58:54 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "hello-san-francisco-mixtape",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "hello-san-francisco-mixtape",
				"stem": "index",
				"path": "hello-san-francisco-mixtape/index.md"
			},
			"requirePath": "hello-san-francisco-mixtape/index.md",
			"path": "/hello-san-francisco-mixtape/",
			"data": {
				"title": "Hello San Francisco: Mixtape",
				"date": "2014-09-30 12:30:15 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "hipster-outtakes",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "hipster-outtakes",
				"stem": "index",
				"path": "hipster-outtakes/index.md"
			},
			"requirePath": "hipster-outtakes/index.md",
			"path": "/hipster-outtakes/",
			"data": {
				"title": "Hipster Outtakes",
				"date": "2012-08-01 11:17:54 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "hipster-und-deutsche-vorurteile",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "hipster-und-deutsche-vorurteile",
				"stem": "index",
				"path": "hipster-und-deutsche-vorurteile/index.md"
			},
			"requirePath": "hipster-und-deutsche-vorurteile/index.md",
			"path": "/hipster-und-deutsche-vorurteile/",
			"data": {
				"title": "San Francisco Hipstercity und deutsche Vorurteile",
				"date": "2012-08-30 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "homestory",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "homestory",
				"stem": "index",
				"path": "homestory/index.md"
			},
			"requirePath": "homestory/index.md",
			"path": "/homestory/",
			"data": {
				"title": "Die Ada Blitzkrieg Homestory",
				"date": "2011-10-10 17:20:05 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "horses-and-their-dream-of-ada",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "horses-and-their-dream-of-ada",
				"stem": "index",
				"path": "horses-and-their-dream-of-ada/index.md"
			},
			"requirePath": "horses-and-their-dream-of-ada/index.md",
			"path": "/horses-and-their-dream-of-ada/",
			"data": {
				"title": "Horses and their dream of Ada",
				"date": "2012-03-19 16:05:34 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "how-to-hack-pesto",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "how-to-hack-pesto",
				"stem": "index",
				"path": "how-to-hack-pesto/index.md"
			},
			"requirePath": "how-to-hack-pesto/index.md",
			"path": "/how-to-hack-pesto/",
			"data": {
				"title": "How to hack pesto",
				"date": "2012-06-14 16:46:18 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "how-to-make-kimchi-fried-rice-with-tofu",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "how-to-make-kimchi-fried-rice-with-tofu",
				"stem": "index",
				"path": "how-to-make-kimchi-fried-rice-with-tofu/index.md"
			},
			"requirePath": "how-to-make-kimchi-fried-rice-with-tofu/index.md",
			"path": "/how-to-make-kimchi-fried-rice-with-tofu/",
			"data": {
				"title": "How to make Kimchi Fried Rice with Tofu",
				"date": "2017-03-14 10:22:09 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "i-talked-die-interviews",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "i-talked-die-interviews",
				"stem": "index",
				"path": "i-talked-die-interviews/index.md"
			},
			"requirePath": "i-talked-die-interviews/index.md",
			"path": "/i-talked-die-interviews/",
			"data": {
				"title": "I talked - die Interviews",
				"date": "2014-04-30 14:42:31 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ich-mochte-teil-einer-jugendgefahrdung-sein",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ich-mochte-teil-einer-jugendgefahrdung-sein",
				"stem": "index",
				"path": "ich-mochte-teil-einer-jugendgefahrdung-sein/index.md"
			},
			"requirePath": "ich-mochte-teil-einer-jugendgefahrdung-sein/index.md",
			"path": "/ich-mochte-teil-einer-jugendgefahrdung-sein/",
			"data": {
				"title": "Ich möchte Teil einer Jugendgefährdung sein",
				"date": "2011-09-11 15:54:09 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ich-muss-etwas-beichten",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ich-muss-etwas-beichten",
				"stem": "index",
				"path": "ich-muss-etwas-beichten/index.md"
			},
			"requirePath": "ich-muss-etwas-beichten/index.md",
			"path": "/ich-muss-etwas-beichten/",
			"data": {
				"title": "Ich muss etwas beichten",
				"date": "2015-03-05 10:04:28 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "im-test-vietnamesischer-groemarkt",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "im-test-vietnamesischer-groemarkt",
				"stem": "index",
				"path": "im-test-vietnamesischer-groemarkt/index.md"
			},
			"requirePath": "im-test-vietnamesischer-groemarkt/index.md",
			"path": "/im-test-vietnamesischer-groemarkt/",
			"data": {
				"title": "Im Test: Vietnamesischer Großmarkt",
				"date": "2011-08-17 17:31:59 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "interessengemeinschaft-batiken-n-e-v",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "interessengemeinschaft-batiken-n-e-v",
				"stem": "index",
				"path": "interessengemeinschaft-batiken-n-e-v/index.md"
			},
			"requirePath": "interessengemeinschaft-batiken-n-e-v/index.md",
			"path": "/interessengemeinschaft-batiken-n-e-v/",
			"data": {
				"title": "Interessengemeinschaft Batiken n.e.V.",
				"date": "2011-06-23 11:54:39 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-album-preview-mit-lady-gaga-im-berghain",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-album-preview-mit-lady-gaga-im-berghain",
				"stem": "index",
				"path": "intro-album-preview-mit-lady-gaga-im-berghain/index.md"
			},
			"requirePath": "intro-album-preview-mit-lady-gaga-im-berghain/index.md",
			"path": "/intro-album-preview-mit-lady-gaga-im-berghain/",
			"data": {
				"title": "INTRO Album Preview mit Lady Gaga im Berghain",
				"date": "2014-01-09 09:27:54 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-jahrescharts-2012",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-jahrescharts-2012",
				"stem": "index",
				"path": "intro-jahrescharts-2012/index.md"
			},
			"requirePath": "intro-jahrescharts-2012/index.md",
			"path": "/intro-jahrescharts-2012/",
			"data": {
				"title": "INTRO Jahrescharts 2012",
				"date": "2012-12-02 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-jahrescharts",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-jahrescharts",
				"stem": "index",
				"path": "intro-jahrescharts/index.md"
			},
			"requirePath": "intro-jahrescharts/index.md",
			"path": "/intro-jahrescharts/",
			"data": {
				"title": "INTRO Jahrescharts",
				"date": "2011-12-09 12:09:31 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe",
				"stem": "index",
				"path": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe/index.md"
			},
			"requirePath": "intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe/index.md",
			"path": "/intro-kolumne-20-dinge-die-ich-bei-wetten-dass-gelernt-habe/",
			"data": {
				"title": "INTRO Kolumne: 20 Dinge, die ich bei Wetten, dass...? gelernt habe",
				"date": "2013-08-27 09:53:38 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-breaking-bad-in-deutschland",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-breaking-bad-in-deutschland",
				"stem": "index",
				"path": "intro-kolumne-breaking-bad-in-deutschland/index.md"
			},
			"requirePath": "intro-kolumne-breaking-bad-in-deutschland/index.md",
			"path": "/intro-kolumne-breaking-bad-in-deutschland/",
			"data": {
				"title": "INTRO Kolumne: Breaking Bad in Deutschland",
				"date": "2013-08-29 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort",
				"stem": "index",
				"path": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort/index.md"
			},
			"requirePath": "intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort/index.md",
			"path": "/intro-kolumne-csi-ottweiler-die-deutschen-und-ihr-tatort/",
			"data": {
				"title": "INTRO Kolumne: CSI Ottweiler  Die Deutschen und ihr Tatort",
				"date": "2013-08-27 09:52:33 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-dschungelcamp",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-dschungelcamp",
				"stem": "index",
				"path": "intro-kolumne-dschungelcamp/index.md"
			},
			"requirePath": "intro-kolumne-dschungelcamp/index.md",
			"path": "/intro-kolumne-dschungelcamp/",
			"data": {
				"title": "INTRO Kolumne: Dschungelcamp",
				"date": "2014-01-27 11:13:34 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-fernseh-dit",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-fernseh-dit",
				"stem": "index",
				"path": "intro-kolumne-fernseh-dit/index.md"
			},
			"requirePath": "intro-kolumne-fernseh-dit/index.md",
			"path": "/intro-kolumne-fernseh-dit/",
			"data": {
				"title": "INTRO Kolumne: Fernseh-Diät",
				"date": "2014-01-09 09:17:53 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-germanys-next-hochwasser-contest",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-germanys-next-hochwasser-contest",
				"stem": "index",
				"path": "intro-kolumne-germanys-next-hochwasser-contest/index.md"
			},
			"requirePath": "intro-kolumne-germanys-next-hochwasser-contest/index.md",
			"path": "/intro-kolumne-germanys-next-hochwasser-contest/",
			"data": {
				"title": "INTRO Kolumne: Germanys Next Hochwasser-Contest",
				"date": "2013-08-27 09:53:10 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-got-to-dance",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-got-to-dance",
				"stem": "index",
				"path": "intro-kolumne-got-to-dance/index.md"
			},
			"requirePath": "intro-kolumne-got-to-dance/index.md",
			"path": "/intro-kolumne-got-to-dance/",
			"data": {
				"title": "INTRO Kolumne: Got To Dance",
				"date": "2013-08-27 09:53:18 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank",
				"stem": "index",
				"path": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank/index.md"
			},
			"requirePath": "intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank/index.md",
			"path": "/intro-kolumne-markus-lanz-ein-backstreet-boy-auf-der-ersatzbank/",
			"data": {
				"title": "INTRO Kolumne: Markus Lanz, ein Backstreet Boy auf der Ersatzbank",
				"date": "2014-01-09 09:22:07 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker",
				"stem": "index",
				"path": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker/index.md"
			},
			"requirePath": "intro-kolumne-markus-lanz-und-die-ganzkrperhunziker/index.md",
			"path": "/intro-kolumne-markus-lanz-und-die-ganzkrperhunziker/",
			"data": {
				"title": "INTRO Kolumne: Markus Lanz und die Ganzkörperhunziker",
				"date": "2013-08-27 09:53:24 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-sommerloch",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-sommerloch",
				"stem": "index",
				"path": "intro-kolumne-sommerloch/index.md"
			},
			"requirePath": "intro-kolumne-sommerloch/index.md",
			"path": "/intro-kolumne-sommerloch/",
			"data": {
				"title": "INTRO Kolumne: Sommerloch",
				"date": "2013-08-27 09:53:32 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-stuckrad-barre",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-stuckrad-barre",
				"stem": "index",
				"path": "intro-kolumne-stuckrad-barre/index.md"
			},
			"requirePath": "intro-kolumne-stuckrad-barre/index.md",
			"path": "/intro-kolumne-stuckrad-barre/",
			"data": {
				"title": "INTRO Kolumne: Stuckrad-Barre",
				"date": "2013-09-26 15:01:52 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte",
				"stem": "index",
				"path": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte/index.md"
			},
			"requirePath": "intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte/index.md",
			"path": "/intro-kolumne-warum-sich-der-kleine-lord-ruhig-mal-die-haare-waschen-knnte/",
			"data": {
				"title": "INTRO Kolumne: Warum sich der kleine Lord ruhig mal die Haare waschen könnte",
				"date": "2014-01-09 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ist-eine-schlgerei-mit-donato-undenkbar",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ist-eine-schlgerei-mit-donato-undenkbar",
				"stem": "index",
				"path": "ist-eine-schlgerei-mit-donato-undenkbar/index.md"
			},
			"requirePath": "ist-eine-schlgerei-mit-donato-undenkbar/index.md",
			"path": "/ist-eine-schlgerei-mit-donato-undenkbar/",
			"data": {
				"title": "Ist eine Schlägerei mit Donato undenkbar?",
				"date": "2014-03-10 13:14:44 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "jeder-ist-jetzt-30",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "jeder-ist-jetzt-30",
				"stem": "index",
				"path": "jeder-ist-jetzt-30/index.md"
			},
			"requirePath": "jeder-ist-jetzt-30/index.md",
			"path": "/jeder-ist-jetzt-30/",
			"data": {
				"title": "Jeder ist 30",
				"date": "2015-08-12 08:30:43 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "kampagne-zum-fremdschamen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "kampagne-zum-fremdschamen",
				"stem": "index",
				"path": "kampagne-zum-fremdschamen/index.md"
			},
			"requirePath": "kampagne-zum-fremdschamen/index.md",
			"path": "/kampagne-zum-fremdschamen/",
			"data": {
				"title": "Kampagne zum Fremdschämen",
				"date": "2012-04-18 10:23:18 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen",
				"stem": "index",
				"path": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen/index.md"
			},
			"requirePath": "katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen/index.md",
			"path": "/katzen-und-laser-lauert-die-gefahr-in-den-kleinanzeigen/",
			"data": {
				"title": "Katzen und Laser, lauert der Tod in den Kleinanzeigen?",
				"date": "2012-10-10 13:22:28 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "kaufen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "kaufen",
				"stem": "index",
				"path": "kaufen/index.md"
			},
			"requirePath": "kaufen/index.md",
			"path": "/kaufen/",
			"data": {
				"title": "kaufen",
				"date": "2012-12-16 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "keywords",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "keywords",
				"stem": "index",
				"path": "keywords/index.md"
			},
			"requirePath": "keywords/index.md",
			"path": "/keywords/",
			"data": {
				"title": "Keywords und Dackelkrieg",
				"date": "2011-11-17 11:09:42 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "kotti-couture",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "kotti-couture",
				"stem": "index",
				"path": "kotti-couture/index.md"
			},
			"requirePath": "kotti-couture/index.md",
			"path": "/kotti-couture/",
			"data": {
				"title": "Kotti Couture",
				"date": "2011-04-21 15:25:53 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "kultur-enlargement",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "kultur-enlargement",
				"stem": "index",
				"path": "kultur-enlargement/index.md"
			},
			"requirePath": "kultur-enlargement/index.md",
			"path": "/kultur-enlargement/",
			"data": {
				"title": "Kultur Enlargement",
				"date": "2011-04-27 15:19:39 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "lauter-verlorene-manner-frauenquote-und-feminismus",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "lauter-verlorene-manner-frauenquote-und-feminismus",
				"stem": "index",
				"path": "lauter-verlorene-manner-frauenquote-und-feminismus/index.md"
			},
			"requirePath": "lauter-verlorene-manner-frauenquote-und-feminismus/index.md",
			"path": "/lauter-verlorene-manner-frauenquote-und-feminismus/",
			"data": {
				"title": "'Lauter verlorene Männer', Frauenquote und Feminismus",
				"date": "2012-06-07 16:35:09 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "learn-the-kitchenbasics-salsa",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "learn-the-kitchenbasics-salsa",
				"stem": "index",
				"path": "learn-the-kitchenbasics-salsa/index.md"
			},
			"requirePath": "learn-the-kitchenbasics-salsa/index.md",
			"path": "/learn-the-kitchenbasics-salsa/",
			"data": {
				"title": "Learn The Kitchenbasics: Salsa",
				"date": "2012-11-01 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "learn-the-kitchenbasics-selfmade-pasta",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "learn-the-kitchenbasics-selfmade-pasta",
				"stem": "index",
				"path": "learn-the-kitchenbasics-selfmade-pasta/index.md"
			},
			"requirePath": "learn-the-kitchenbasics-selfmade-pasta/index.md",
			"path": "/learn-the-kitchenbasics-selfmade-pasta/",
			"data": {
				"title": "Learn The Kitchenbasics: Selfmade Pasta",
				"date": "2012-11-06 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "lisa-rank-die-klo-im-hals-autorin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "lisa-rank-die-klo-im-hals-autorin",
				"stem": "index",
				"path": "lisa-rank-die-klo-im-hals-autorin/index.md"
			},
			"requirePath": "lisa-rank-die-klo-im-hals-autorin/index.md",
			"path": "/lisa-rank-die-klo-im-hals-autorin/",
			"data": {
				"title": "Lisa Rank, die Kloß-Im-Hals-Autorin",
				"date": "2013-04-08 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "listen-sind-das-neue-schwarz",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "listen-sind-das-neue-schwarz",
				"stem": "index",
				"path": "listen-sind-das-neue-schwarz/index.md"
			},
			"requirePath": "listen-sind-das-neue-schwarz/index.md",
			"path": "/listen-sind-das-neue-schwarz/",
			"data": {
				"title": "Listen sind das neue Schwarz",
				"date": "2014-05-15 16:49:03 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "lokalradiomoderatoren-beim-bundesvision-songcontest",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "lokalradiomoderatoren-beim-bundesvision-songcontest",
				"stem": "index",
				"path": "lokalradiomoderatoren-beim-bundesvision-songcontest/index.md"
			},
			"requirePath": "lokalradiomoderatoren-beim-bundesvision-songcontest/index.md",
			"path": "/lokalradiomoderatoren-beim-bundesvision-songcontest/",
			"data": {
				"title": "Lokalradiomoderatoren beim Bundesvisíon Songcontest",
				"date": "2011-09-30 16:06:27 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mal-ganz-unter-uns-rezeptlieblinge",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mal-ganz-unter-uns-rezeptlieblinge",
				"stem": "index",
				"path": "mal-ganz-unter-uns-rezeptlieblinge/index.md"
			},
			"requirePath": "mal-ganz-unter-uns-rezeptlieblinge/index.md",
			"path": "/mal-ganz-unter-uns-rezeptlieblinge/",
			"data": {
				"title": "Mal ganz unter uns: Rezeptlieblinge",
				"date": "2015-05-29 09:25:46 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "marathonmann",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "marathonmann",
				"stem": "index",
				"path": "marathonmann/index.md"
			},
			"requirePath": "marathonmann/index.md",
			"path": "/marathonmann/",
			"data": {
				"title": "Marathonmann",
				"date": "2011-07-14 15:28:39 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mein-neues-buch-ist-erschienen-die-strenge",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mein-neues-buch-ist-erschienen-die-strenge",
				"stem": "index",
				"path": "mein-neues-buch-ist-erschienen-die-strenge/index.md"
			},
			"requirePath": "mein-neues-buch-ist-erschienen-die-strenge/index.md",
			"path": "/mein-neues-buch-ist-erschienen-die-strenge/",
			"data": {
				"title": "Mein neues Buch ist erschienen: Die Strenge",
				"date": "2013-09-26 15:19:09 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mein-zweiter-roman---verlage-vor",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mein-zweiter-roman---verlage-vor",
				"stem": "index",
				"path": "mein-zweiter-roman---verlage-vor/index.md"
			},
			"requirePath": "mein-zweiter-roman---verlage-vor/index.md",
			"path": "/mein-zweiter-roman---verlage-vor/",
			"data": {
				"title": "Mein zweiter Roman - Verlage vor!",
				"date": "2014-03-14 14:32:14 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "meine-leistungen-als-freiberuflerin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "meine-leistungen-als-freiberuflerin",
				"stem": "index",
				"path": "meine-leistungen-als-freiberuflerin/index.md"
			},
			"requirePath": "meine-leistungen-als-freiberuflerin/index.md",
			"path": "/meine-leistungen-als-freiberuflerin/",
			"data": {
				"title": "Meine Leistungen als Freiberuflerin",
				"date": "2013-04-09 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "menschen-carmen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "menschen-carmen",
				"stem": "index",
				"path": "menschen-carmen/index.md"
			},
			"requirePath": "menschen-carmen/index.md",
			"path": "/menschen-carmen/",
			"data": {
				"title": "Menschen: Carmen",
				"date": "2011-09-13 14:57:55 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mira-lykke-im-interview",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mira-lykke-im-interview",
				"stem": "index",
				"path": "mira-lykke-im-interview/index.md"
			},
			"requirePath": "mira-lykke-im-interview/index.md",
			"path": "/mira-lykke-im-interview/",
			"data": {
				"title": "Mira Lykke im Interview",
				"date": "2013-04-10 15:29:57 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-anatolian-psychedelic",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-anatolian-psychedelic",
				"stem": "index",
				"path": "mixtape-anatolian-psychedelic/index.md"
			},
			"requirePath": "mixtape-anatolian-psychedelic/index.md",
			"path": "/mixtape-anatolian-psychedelic/",
			"data": {
				"title": "Mixtape: Anatolian Psychedelic",
				"date": "2016-05-23 09:03:38 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-april-sheesh-days",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-april-sheesh-days",
				"stem": "index",
				"path": "mixtape-april-sheesh-days/index.md"
			},
			"requirePath": "mixtape-april-sheesh-days/index.md",
			"path": "/mixtape-april-sheesh-days/",
			"data": {
				"title": "Mixtape April: Sheesh Days",
				"date": "2014-04-10 15:51:34 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-birddog",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-birddog",
				"stem": "index",
				"path": "mixtape-birddog/index.md"
			},
			"requirePath": "mixtape-birddog/index.md",
			"path": "/mixtape-birddog/",
			"data": {
				"title": "Mixtape: BIRDDOG",
				"date": "2014-06-09 20:49:48 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-butter-gang",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-butter-gang",
				"stem": "index",
				"path": "mixtape-butter-gang/index.md"
			},
			"requirePath": "mixtape-butter-gang/index.md",
			"path": "/mixtape-butter-gang/",
			"data": {
				"title": "Mixtape: Butter Gang",
				"date": "2015-07-26 11:49:59 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-chickengirlz",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-chickengirlz",
				"stem": "index",
				"path": "mixtape-chickengirlz/index.md"
			},
			"requirePath": "mixtape-chickengirlz/index.md",
			"path": "/mixtape-chickengirlz/",
			"data": {
				"title": "Mixtape: Chickengirlz",
				"date": "2015-05-14 15:07:57 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-entfremdung-von-der-leichtigkeit",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-entfremdung-von-der-leichtigkeit",
				"stem": "index",
				"path": "mixtape-entfremdung-von-der-leichtigkeit/index.md"
			},
			"requirePath": "mixtape-entfremdung-von-der-leichtigkeit/index.md",
			"path": "/mixtape-entfremdung-von-der-leichtigkeit/",
			"data": {
				"title": "Mixtape - Entfremdung von der Leichtigkeit",
				"date": "2012-10-11 14:24:22 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-fabruar-fap-fap-fap",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-fabruar-fap-fap-fap",
				"stem": "index",
				"path": "mixtape-fabruar-fap-fap-fap/index.md"
			},
			"requirePath": "mixtape-fabruar-fap-fap-fap/index.md",
			"path": "/mixtape-fabruar-fap-fap-fap/",
			"data": {
				"title": "Mixtape Fabruar: Fap Fap Fap",
				"date": "2014-02-03 10:18:36 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-fuck-tatort",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-fuck-tatort",
				"stem": "index",
				"path": "mixtape-fuck-tatort/index.md"
			},
			"requirePath": "mixtape-fuck-tatort/index.md",
			"path": "/mixtape-fuck-tatort/",
			"data": {
				"title": "Mixtape: Fuck Tatort",
				"date": "2015-01-18 18:14:46 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-goodbye-california",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-goodbye-california",
				"stem": "index",
				"path": "mixtape-goodbye-california/index.md"
			},
			"requirePath": "mixtape-goodbye-california/index.md",
			"path": "/mixtape-goodbye-california/",
			"data": {
				"title": "Mixtape: Goodbye California!",
				"date": "2014-11-11 00:56:55 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-hasenscharte",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-hasenscharte",
				"stem": "index",
				"path": "mixtape-hasenscharte/index.md"
			},
			"requirePath": "mixtape-hasenscharte/index.md",
			"path": "/mixtape-hasenscharte/",
			"data": {
				"title": "Mixtape: Hasenscharte",
				"date": "2015-04-03 09:49:32 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-howl-geheule",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-howl-geheule",
				"stem": "index",
				"path": "mixtape-howl-geheule/index.md"
			},
			"requirePath": "mixtape-howl-geheule/index.md",
			"path": "/mixtape-howl-geheule/",
			"data": {
				"title": "Mixtape: Howl Geheule",
				"date": "2015-05-21 12:22:57 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-august-the-miniwurstelmonth",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-august-the-miniwurstelmonth",
				"stem": "index",
				"path": "mixtape-im-august-the-miniwurstelmonth/index.md"
			},
			"requirePath": "mixtape-im-august-the-miniwurstelmonth/index.md",
			"path": "/mixtape-im-august-the-miniwurstelmonth/",
			"data": {
				"title": "Mixtape im August: The Miniwurstelmonth",
				"date": "2013-07-30 13:44:12 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-dezember-no-wanderlust",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-dezember-no-wanderlust",
				"stem": "index",
				"path": "mixtape-im-dezember-no-wanderlust/index.md"
			},
			"requirePath": "mixtape-im-dezember-no-wanderlust/index.md",
			"path": "/mixtape-im-dezember-no-wanderlust/",
			"data": {
				"title": "Mixtape im Dezember: No Wanderlust",
				"date": "2013-11-26 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-januar-fucktthatshit",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-januar-fucktthatshit",
				"stem": "index",
				"path": "mixtape-im-januar-fucktthatshit/index.md"
			},
			"requirePath": "mixtape-im-januar-fucktthatshit/index.md",
			"path": "/mixtape-im-januar-fucktthatshit/",
			"data": {
				"title": "Mixtape im Januar: FUCKTTHATSHIT!",
				"date": "2014-01-09 09:10:21 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-juli-adrette-ausreden",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-juli-adrette-ausreden",
				"stem": "index",
				"path": "mixtape-im-juli-adrette-ausreden/index.md"
			},
			"requirePath": "mixtape-im-juli-adrette-ausreden/index.md",
			"path": "/mixtape-im-juli-adrette-ausreden/",
			"data": {
				"title": "Mixtape im Juli: Adrette Ausreden",
				"date": "2013-07-10 08:08:16 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-juni-the-liverwurst-diaries",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-juni-the-liverwurst-diaries",
				"stem": "index",
				"path": "mixtape-im-juni-the-liverwurst-diaries/index.md"
			},
			"requirePath": "mixtape-im-juni-the-liverwurst-diaries/index.md",
			"path": "/mixtape-im-juni-the-liverwurst-diaries/",
			"data": {
				"title": "Mixtape im Juni: The Liverwurst Diaries",
				"date": "2013-06-07 14:59:06 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-mai-peng",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-mai-peng",
				"stem": "index",
				"path": "mixtape-im-mai-peng/index.md"
			},
			"requirePath": "mixtape-im-mai-peng/index.md",
			"path": "/mixtape-im-mai-peng/",
			"data": {
				"title": "Mixtape im Mai: Peng",
				"date": "2013-05-08 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-november-schnaps-and-zweifel",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-november-schnaps-and-zweifel",
				"stem": "index",
				"path": "mixtape-im-november-schnaps-and-zweifel/index.md"
			},
			"requirePath": "mixtape-im-november-schnaps-and-zweifel/index.md",
			"path": "/mixtape-im-november-schnaps-and-zweifel/",
			"data": {
				"title": "Mixtape im November: Schnaps and Zweifel",
				"date": "2013-11-02 09:50:39 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-oktober-the-darkness-lights-you-up",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-oktober-the-darkness-lights-you-up",
				"stem": "index",
				"path": "mixtape-im-oktober-the-darkness-lights-you-up/index.md"
			},
			"requirePath": "mixtape-im-oktober-the-darkness-lights-you-up/index.md",
			"path": "/mixtape-im-oktober-the-darkness-lights-you-up/",
			"data": {
				"title": "Mixtape im Oktober: The Darkness Lights You Up",
				"date": "2013-09-26 08:44:10 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-im-september-goodbye-flutschfinger",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-im-september-goodbye-flutschfinger",
				"stem": "index",
				"path": "mixtape-im-september-goodbye-flutschfinger/index.md"
			},
			"requirePath": "mixtape-im-september-goodbye-flutschfinger/index.md",
			"path": "/mixtape-im-september-goodbye-flutschfinger/",
			"data": {
				"title": "Mixtape im September: Goodbye Flutschfinger",
				"date": "2013-08-26 15:47:38 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-klammbumm",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-klammbumm",
				"stem": "index",
				"path": "mixtape-klammbumm/index.md"
			},
			"requirePath": "mixtape-klammbumm/index.md",
			"path": "/mixtape-klammbumm/",
			"data": {
				"title": "Mixtape: Klammbumm",
				"date": "2015-03-07 10:48:41 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-mai-what-the",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-mai-what-the",
				"stem": "index",
				"path": "mixtape-mai-what-the/index.md"
			},
			"requirePath": "mixtape-mai-what-the/index.md",
			"path": "/mixtape-mai-what-the/",
			"data": {
				"title": "Mixtape Mai: WHAT THE",
				"date": "2014-05-01 16:25:46 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-marzipanschnaps-und-gyroskekse",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-marzipanschnaps-und-gyroskekse",
				"stem": "index",
				"path": "mixtape-marzipanschnaps-und-gyroskekse/index.md"
			},
			"requirePath": "mixtape-marzipanschnaps-und-gyroskekse/index.md",
			"path": "/mixtape-marzipanschnaps-und-gyroskekse/",
			"data": {
				"title": "Mixtape: Marzipanschnaps und Gyroskekse",
				"date": "2013-10-15 15:12:39 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-monaco-mini",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-monaco-mini",
				"stem": "index",
				"path": "mixtape-monaco-mini/index.md"
			},
			"requirePath": "mixtape-monaco-mini/index.md",
			"path": "/mixtape-monaco-mini/",
			"data": {
				"title": "Mixtape: Monaco Mini",
				"date": "2015-07-18 07:54:09 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-mrz-fuck-you-eiscreme",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-mrz-fuck-you-eiscreme",
				"stem": "index",
				"path": "mixtape-mrz-fuck-you-eiscreme/index.md"
			},
			"requirePath": "mixtape-mrz-fuck-you-eiscreme/index.md",
			"path": "/mixtape-mrz-fuck-you-eiscreme/",
			"data": {
				"title": "Mixtape März: Fuck You Eiscreme",
				"date": "2014-02-26 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-next-stop-down",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-next-stop-down",
				"stem": "index",
				"path": "mixtape-next-stop-down/index.md"
			},
			"requirePath": "mixtape-next-stop-down/index.md",
			"path": "/mixtape-next-stop-down/",
			"data": {
				"title": "Mixtape: Next Stop - Down",
				"date": "2014-07-24 14:25:25 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-oh-komm-ohn",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-oh-komm-ohn",
				"stem": "index",
				"path": "mixtape-oh-komm-ohn/index.md"
			},
			"requirePath": "mixtape-oh-komm-ohn/index.md",
			"path": "/mixtape-oh-komm-ohn/",
			"data": {
				"title": "Mixtape: Oh komm ohn",
				"date": "2015-10-01 12:56:51 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-pappa-bear",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-pappa-bear",
				"stem": "index",
				"path": "mixtape-pappa-bear/index.md"
			},
			"requirePath": "mixtape-pappa-bear/index.md",
			"path": "/mixtape-pappa-bear/",
			"data": {
				"title": "Mixtape: Pappa Bear",
				"date": "2015-02-13 14:42:27 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-pizza-christmas",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-pizza-christmas",
				"stem": "index",
				"path": "mixtape-pizza-christmas/index.md"
			},
			"requirePath": "mixtape-pizza-christmas/index.md",
			"path": "/mixtape-pizza-christmas/",
			"data": {
				"title": "Mixtape: Pizza Christmas",
				"date": "2014-12-11 13:40:08 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-summer-silly",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-summer-silly",
				"stem": "index",
				"path": "mixtape-summer-silly/index.md"
			},
			"requirePath": "mixtape-summer-silly/index.md",
			"path": "/mixtape-summer-silly/",
			"data": {
				"title": "Mixtape: Summer Silly",
				"date": "2015-09-08 07:23:39 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-supersuper",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-supersuper",
				"stem": "index",
				"path": "mixtape-supersuper/index.md"
			},
			"requirePath": "mixtape-supersuper/index.md",
			"path": "/mixtape-supersuper/",
			"data": {
				"title": "Mixtape: SUPERSUPER",
				"date": "2016-07-06 08:28:34 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-the-birthday-tape",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-the-birthday-tape",
				"stem": "index",
				"path": "mixtape-the-birthday-tape/index.md"
			},
			"requirePath": "mixtape-the-birthday-tape/index.md",
			"path": "/mixtape-the-birthday-tape/",
			"data": {
				"title": "Mixtape: The Birthday Tape",
				"date": "2014-08-14 15:38:50 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixtape-the-catnapper",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "mixtape-the-catnapper",
				"stem": "index",
				"path": "mixtape-the-catnapper/index.md"
			},
			"requirePath": "mixtape-the-catnapper/index.md",
			"path": "/mixtape-the-catnapper/",
			"data": {
				"title": "Mixtape: The Catnapper",
				"date": "2014-09-01 15:10:13 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "nationale-burgerwehr-und-bundnis-gegen-das-pferd",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "nationale-burgerwehr-und-bundnis-gegen-das-pferd",
				"stem": "index",
				"path": "nationale-burgerwehr-und-bundnis-gegen-das-pferd/index.md"
			},
			"requirePath": "nationale-burgerwehr-und-bundnis-gegen-das-pferd/index.md",
			"path": "/nationale-burgerwehr-und-bundnis-gegen-das-pferd/",
			"data": {
				"title": "Nationale Bürgerwehr und Bündnis gegen das Pferd",
				"date": "2011-05-21 12:02:37 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "neid-im-internet",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "neid-im-internet",
				"stem": "index",
				"path": "neid-im-internet/index.md"
			},
			"requirePath": "neid-im-internet/index.md",
			"path": "/neid-im-internet/",
			"data": {
				"title": "Neid im Internet",
				"date": "2012-07-04 15:15:30 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "neues-blitzkrieg-mixtape-3000-den-tights",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "neues-blitzkrieg-mixtape-3000-den-tights",
				"stem": "index",
				"path": "neues-blitzkrieg-mixtape-3000-den-tights/index.md"
			},
			"requirePath": "neues-blitzkrieg-mixtape-3000-den-tights/index.md",
			"path": "/neues-blitzkrieg-mixtape-3000-den-tights/",
			"data": {
				"title": "Neues Blitzkrieg Mixtape 3000 DEN TIGHTS",
				"date": "2012-11-03 14:50:09 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "neues-blitzkrieg-mixtape-turnvatter",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "neues-blitzkrieg-mixtape-turnvatter",
				"stem": "index",
				"path": "neues-blitzkrieg-mixtape-turnvatter/index.md"
			},
			"requirePath": "neues-blitzkrieg-mixtape-turnvatter/index.md",
			"path": "/neues-blitzkrieg-mixtape-turnvatter/",
			"data": {
				"title": "Neues Blitzkrieg Mixtape TURNVATTER",
				"date": "2013-04-03 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "neues-blogdesign-und-mixtape",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "neues-blogdesign-und-mixtape",
				"stem": "index",
				"path": "neues-blogdesign-und-mixtape/index.md"
			},
			"requirePath": "neues-blogdesign-und-mixtape/index.md",
			"path": "/neues-blogdesign-und-mixtape/",
			"data": {
				"title": "Neues Blogdesign und Mixtape:",
				"date": "2014-07-24 14:18:46 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "neuigkeiten-zum-roman",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "neuigkeiten-zum-roman",
				"stem": "index",
				"path": "neuigkeiten-zum-roman/index.md"
			},
			"requirePath": "neuigkeiten-zum-roman/index.md",
			"path": "/neuigkeiten-zum-roman/",
			"data": {
				"title": "Neuigkeiten zum Roman",
				"date": "2012-12-07 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "neulich-im-supermarkt",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "neulich-im-supermarkt",
				"stem": "index",
				"path": "neulich-im-supermarkt/index.md"
			},
			"requirePath": "neulich-im-supermarkt/index.md",
			"path": "/neulich-im-supermarkt/",
			"data": {
				"title": "Neulich im Supermarkt",
				"date": "2012-10-05 14:04:30 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "nightlover-by-max-seedorf-and-airen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "nightlover-by-max-seedorf-and-airen",
				"stem": "index",
				"path": "nightlover-by-max-seedorf-and-airen/index.md"
			},
			"requirePath": "nightlover-by-max-seedorf-and-airen/index.md",
			"path": "/nightlover-by-max-seedorf-and-airen/",
			"data": {
				"title": "Nightlover by Max Seedorf and Airen",
				"date": "2012-01-03 17:45:38 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "omg-tiere-videos-der-woche",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "omg-tiere-videos-der-woche",
				"stem": "index",
				"path": "omg-tiere-videos-der-woche/index.md"
			},
			"requirePath": "omg-tiere-videos-der-woche/index.md",
			"path": "/omg-tiere-videos-der-woche/",
			"data": {
				"title": "OMG Tiere - Videos der Woche",
				"date": "2012-08-22 12:47:44 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ontape-bodi-bill",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ontape-bodi-bill",
				"stem": "index",
				"path": "ontape-bodi-bill/index.md"
			},
			"requirePath": "ontape-bodi-bill/index.md",
			"path": "/ontape-bodi-bill/",
			"data": {
				"title": "Ontape Bodi Bill",
				"date": "2011-06-03 14:08:14 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "optimier-dich-doch-selbst-du-opfer",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "optimier-dich-doch-selbst-du-opfer",
				"stem": "index",
				"path": "optimier-dich-doch-selbst-du-opfer/index.md"
			},
			"requirePath": "optimier-dich-doch-selbst-du-opfer/index.md",
			"path": "/optimier-dich-doch-selbst-du-opfer/",
			"data": {
				"title": "Optimier dich doch selbst, du Opfer!",
				"date": "2014-06-05 15:46:37 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "paint-your-favorite-blogs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "paint-your-favorite-blogs",
				"stem": "index",
				"path": "paint-your-favorite-blogs/index.md"
			},
			"requirePath": "paint-your-favorite-blogs/index.md",
			"path": "/paint-your-favorite-blogs/",
			"data": {
				"title": "Paint your favorite blogs!",
				"date": "2012-08-03 12:29:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "partykapitalismus",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "partykapitalismus",
				"stem": "index",
				"path": "partykapitalismus/index.md"
			},
			"requirePath": "partykapitalismus/index.md",
			"path": "/partykapitalismus/",
			"data": {
				"title": "Partykapitalismus",
				"date": "2011-11-01 17:04:07 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pferdeshow-in-audio",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pferdeshow-in-audio",
				"stem": "index",
				"path": "pferdeshow-in-audio/index.md"
			},
			"requirePath": "pferdeshow-in-audio/index.md",
			"path": "/pferdeshow-in-audio/",
			"data": {
				"title": "Pferdeshow in Audio",
				"date": "2011-07-16 12:02:30 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pimp-your-silvesterbaum-und-gewinne",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pimp-your-silvesterbaum-und-gewinne",
				"stem": "index",
				"path": "pimp-your-silvesterbaum-und-gewinne/index.md"
			},
			"requirePath": "pimp-your-silvesterbaum-und-gewinne/index.md",
			"path": "/pimp-your-silvesterbaum-und-gewinne/",
			"data": {
				"title": "Pimp your Silvesterbaum und gewinne!",
				"date": "2013-12-29 11:46:15 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "platzrebellen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "platzrebellen",
				"stem": "index",
				"path": "platzrebellen/index.md"
			},
			"requirePath": "platzrebellen/index.md",
			"path": "/platzrebellen/",
			"data": {
				"title": "Platzrebellen",
				"date": "2011-07-13 08:10:34 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "podcasts-im-in-love",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "podcasts-im-in-love",
				"stem": "index",
				"path": "podcasts-im-in-love/index.md"
			},
			"requirePath": "podcasts-im-in-love/index.md",
			"path": "/podcasts-im-in-love/",
			"data": {
				"title": "Podcasts, I'm in love!",
				"date": "2015-03-06 16:27:20 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "portfolio",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "portfolio",
				"stem": "index",
				"path": "portfolio/index.md"
			},
			"requirePath": "portfolio/index.md",
			"path": "/portfolio/",
			"data": {
				"title": "PORTFOLIO",
				"date": "2011-04-20 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pr-texte-aus-der-holle-folge-1",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pr-texte-aus-der-holle-folge-1",
				"stem": "index",
				"path": "pr-texte-aus-der-holle-folge-1/index.md"
			},
			"requirePath": "pr-texte-aus-der-holle-folge-1/index.md",
			"path": "/pr-texte-aus-der-holle-folge-1/",
			"data": {
				"title": "PR-Texte aus der Hölle (Folge 1)",
				"date": "2014-08-04 14:52:35 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "prag-kann-das-was",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "prag-kann-das-was",
				"stem": "index",
				"path": "prag-kann-das-was/index.md"
			},
			"requirePath": "prag-kann-das-was/index.md",
			"path": "/prag-kann-das-was/",
			"data": {
				"title": "Prag - kann das was?",
				"date": "2011-09-21 16:27:29 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "presse",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "presse",
				"stem": "index",
				"path": "presse/index.md"
			},
			"requirePath": "presse/index.md",
			"path": "/presse/",
			"data": {
				"title": "PRESSE",
				"date": "2013-06-30 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "prinz-pi-bei-tape-tv",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "prinz-pi-bei-tape-tv",
				"stem": "index",
				"path": "prinz-pi-bei-tape-tv/index.md"
			},
			"requirePath": "prinz-pi-bei-tape-tv/index.md",
			"path": "/prinz-pi-bei-tape-tv/",
			"data": {
				"title": "Prinz Pi bei tape.tv",
				"date": "2011-05-24 08:41:28 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "rassekatzen-glitzer-und-katzenmasse",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "rassekatzen-glitzer-und-katzenmasse",
				"stem": "index",
				"path": "rassekatzen-glitzer-und-katzenmasse/index.md"
			},
			"requirePath": "rassekatzen-glitzer-und-katzenmasse/index.md",
			"path": "/rassekatzen-glitzer-und-katzenmasse/",
			"data": {
				"title": "Rassekatzen, Glitzer und Katzenmasse",
				"date": "2012-01-05 16:52:30 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "regentage",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "regentage",
				"stem": "index",
				"path": "regentage/index.md"
			},
			"requirePath": "regentage/index.md",
			"path": "/regentage/",
			"data": {
				"title": "Regentage",
				"date": "2012-06-20 14:07:47 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sag-es-laut-mir-geht-es-gut",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "sag-es-laut-mir-geht-es-gut",
				"stem": "index",
				"path": "sag-es-laut-mir-geht-es-gut/index.md"
			},
			"requirePath": "sag-es-laut-mir-geht-es-gut/index.md",
			"path": "/sag-es-laut-mir-geht-es-gut/",
			"data": {
				"title": "Sag es laut: Mir geht es gut",
				"date": "2014-05-12 19:02:25 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "san-francisco-food-story",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "san-francisco-food-story",
				"stem": "index",
				"path": "san-francisco-food-story/index.md"
			},
			"requirePath": "san-francisco-food-story/index.md",
			"path": "/san-francisco-food-story/",
			"data": {
				"title": "San Francisco Food Story",
				"date": "2012-09-14 18:30:47 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "schlechte-zeiten-gute-zeiten",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "schlechte-zeiten-gute-zeiten",
				"stem": "index",
				"path": "schlechte-zeiten-gute-zeiten/index.md"
			},
			"requirePath": "schlechte-zeiten-gute-zeiten/index.md",
			"path": "/schlechte-zeiten-gute-zeiten/",
			"data": {
				"title": "Schlechte Zeiten, gute Zeiten - Neues Blitzkrieg HQ",
				"date": "2012-01-31 14:51:19 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion",
				"stem": "index",
				"path": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion/index.md"
			},
			"requirePath": "silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion/index.md",
			"path": "/silenttiffy-ihr-roman-and-the-masters-of-aussiedlerfashion/",
			"data": {
				"title": "Silenttiffy, ihr Roman, and the Masters of Aussiedlerfashion",
				"date": "2012-06-04 11:55:34 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "slowenien-slowakei-oder-so",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "slowenien-slowakei-oder-so",
				"stem": "index",
				"path": "slowenien-slowakei-oder-so/index.md"
			},
			"requirePath": "slowenien-slowakei-oder-so/index.md",
			"path": "/slowenien-slowakei-oder-so/",
			"data": {
				"title": "Slowenien, Slowakei oder so",
				"date": "2011-06-27 16:04:49 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sofawissenschaften",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "sofawissenschaften",
				"stem": "index",
				"path": "sofawissenschaften/index.md"
			},
			"requirePath": "sofawissenschaften/index.md",
			"path": "/sofawissenschaften/",
			"data": {
				"title": "Sofawissenschaften",
				"date": "2012-02-01 09:31:59 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "soundcloud-and-fun",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "soundcloud-and-fun",
				"stem": "index",
				"path": "soundcloud-and-fun/index.md"
			},
			"requirePath": "soundcloud-and-fun/index.md",
			"path": "/soundcloud-and-fun/",
			"data": {
				"title": "SoundCloud and Fun",
				"date": "2012-11-12 14:07:13 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "spannung-vor-dem-release",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "spannung-vor-dem-release",
				"stem": "index",
				"path": "spannung-vor-dem-release/index.md"
			},
			"requirePath": "spannung-vor-dem-release/index.md",
			"path": "/spannung-vor-dem-release/",
			"data": {
				"title": "Spannung vor dem Release",
				"date": "2012-12-15 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "start",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "start",
				"stem": "index",
				"path": "start/index.md"
			},
			"requirePath": "start/index.md",
			"path": "/start/",
			"data": {
				"title": "Start",
				"date": "2011-04-21 15:59:29 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "studiopublikum-frittenbude",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "studiopublikum-frittenbude",
				"stem": "index",
				"path": "studiopublikum-frittenbude/index.md"
			},
			"requirePath": "studiopublikum-frittenbude/index.md",
			"path": "/studiopublikum-frittenbude/",
			"data": {
				"title": "Prominente im Studiopublikum - Teil I: Der Sänger von Frittenbude",
				"date": "2011-07-28 16:12:21 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sukultur",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "sukultur",
				"stem": "index",
				"path": "sukultur/index.md"
			},
			"requirePath": "sukultur/index.md",
			"path": "/sukultur/",
			"data": {
				"title": "SUKULTUR",
				"date": "2013-10-07 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "swag-guide-to-berlin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "swag-guide-to-berlin",
				"stem": "index",
				"path": "swag-guide-to-berlin/index.md"
			},
			"requirePath": "swag-guide-to-berlin/index.md",
			"path": "/swag-guide-to-berlin/",
			"data": {
				"title": "Swag-Guide to Berlin",
				"date": "2011-05-30 15:58:50 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "techno-2pac",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "techno-2pac",
				"stem": "index",
				"path": "techno-2pac/index.md"
			},
			"requirePath": "techno-2pac/index.md",
			"path": "/techno-2pac/",
			"data": {
				"title": "Techno 2Pac",
				"date": "2012-02-14 10:47:37 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "text-fur-meine-demente-grosmutter",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "text-fur-meine-demente-grosmutter",
				"stem": "index",
				"path": "text-fur-meine-demente-grosmutter/index.md"
			},
			"requirePath": "text-fur-meine-demente-grosmutter/index.md",
			"path": "/text-fur-meine-demente-grosmutter/",
			"data": {
				"title": "Text für meine demente Großmutter",
				"date": "2012-11-16 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "textkrieg-buchen",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "textkrieg-buchen",
				"stem": "index",
				"path": "textkrieg-buchen/index.md"
			},
			"requirePath": "textkrieg-buchen/index.md",
			"path": "/textkrieg-buchen/",
			"data": {
				"title": "Textkrieg buchen",
				"date": "2014-02-25 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "textkrieg-goes-to-california",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "textkrieg-goes-to-california",
				"stem": "index",
				"path": "textkrieg-goes-to-california/index.md"
			},
			"requirePath": "textkrieg-goes-to-california/index.md",
			"path": "/textkrieg-goes-to-california/",
			"data": {
				"title": "Textkrieg goes to California",
				"date": "2012-08-21 06:43:37 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "the-guide-to-dont-give-a-fuck",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "the-guide-to-dont-give-a-fuck",
				"stem": "index",
				"path": "the-guide-to-dont-give-a-fuck/index.md"
			},
			"requirePath": "the-guide-to-dont-give-a-fuck/index.md",
			"path": "/the-guide-to-dont-give-a-fuck/",
			"data": {
				"title": "The Guide To Don´t Give A Fuck",
				"date": "2014-03-05 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "the-incredible-banana-bread-with-pecan-ice-cream",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "the-incredible-banana-bread-with-pecan-ice-cream",
				"stem": "index",
				"path": "the-incredible-banana-bread-with-pecan-ice-cream/index.md"
			},
			"requirePath": "the-incredible-banana-bread-with-pecan-ice-cream/index.md",
			"path": "/the-incredible-banana-bread-with-pecan-ice-cream/",
			"data": {
				"title": "Incredible banana bread with pecan ice cream",
				"date": "2012-11-06 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "thor-steinar-der-vorbereitungsnazis",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "thor-steinar-der-vorbereitungsnazis",
				"stem": "index",
				"path": "thor-steinar-der-vorbereitungsnazis/index.md"
			},
			"requirePath": "thor-steinar-der-vorbereitungsnazis/index.md",
			"path": "/thor-steinar-der-vorbereitungsnazis/",
			"data": {
				"title": "Thor Steinar der Vorbereitungsnazis",
				"date": "2011-07-07 08:09:41 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "tkkg-und-der-affen-und-vogelpark",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "tkkg-und-der-affen-und-vogelpark",
				"stem": "index",
				"path": "tkkg-und-der-affen-und-vogelpark/index.md"
			},
			"requirePath": "tkkg-und-der-affen-und-vogelpark/index.md",
			"path": "/tkkg-und-der-affen-und-vogelpark/",
			"data": {
				"title": "TKKG und der Affen- und Vogelpark",
				"date": "2011-07-22 12:53:36 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "welt-funk-blitzkrieg-weihnachtsgruee-c60",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "welt-funk-blitzkrieg-weihnachtsgruee-c60",
				"stem": "index",
				"path": "welt-funk-blitzkrieg-weihnachtsgruee-c60/index.md"
			},
			"requirePath": "welt-funk-blitzkrieg-weihnachtsgruee-c60/index.md",
			"path": "/welt-funk-blitzkrieg-weihnachtsgruee-c60/",
			"data": {
				"title": "WELT FUNK Blitzkrieg Weihnachtsgrüße C60",
				"date": "2011-12-24 14:20:28 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "werbeunterbrechung",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "werbeunterbrechung",
				"stem": "index",
				"path": "werbeunterbrechung/index.md"
			},
			"requirePath": "werbeunterbrechung/index.md",
			"path": "/werbeunterbrechung/",
			"data": {
				"title": "Werbeunterbrechung",
				"date": "2011-11-28 16:55:21 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "where-hipsters-get-their-coffee",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "where-hipsters-get-their-coffee",
				"stem": "index",
				"path": "where-hipsters-get-their-coffee/index.md"
			},
			"requirePath": "where-hipsters-get-their-coffee/index.md",
			"path": "/where-hipsters-get-their-coffee/",
			"data": {
				"title": "Where hipsters get their coffee",
				"date": "2013-09-24 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "wie-die-welt-quellen-aus-meinen-tweets-streicht",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "wie-die-welt-quellen-aus-meinen-tweets-streicht",
				"stem": "index",
				"path": "wie-die-welt-quellen-aus-meinen-tweets-streicht/index.md"
			},
			"requirePath": "wie-die-welt-quellen-aus-meinen-tweets-streicht/index.md",
			"path": "/wie-die-welt-quellen-aus-meinen-tweets-streicht/",
			"data": {
				"title": "Wie die WELT Quellen aus meinen Tweets streicht",
				"date": "2012-01-11 16:44:31 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte",
				"stem": "index",
				"path": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte/index.md"
			},
			"requirePath": "wie-ich-2kg-fleisch-in-den-slow-cooker-stammte/index.md",
			"path": "/wie-ich-2kg-fleisch-in-den-slow-cooker-stammte/",
			"data": {
				"title": "Wie ich 2kg Fleisch in den Slow Cooker stämmte",
				"date": "2012-11-19 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "wie-ist-das-so-als-freiberufler",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "wie-ist-das-so-als-freiberufler",
				"stem": "index",
				"path": "wie-ist-das-so-als-freiberufler/index.md"
			},
			"requirePath": "wie-ist-das-so-als-freiberufler/index.md",
			"path": "/wie-ist-das-so-als-freiberufler/",
			"data": {
				"title": "Wie ist das so als Freiberufler?",
				"date": "2011-05-18 13:41:52 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "wie-meine-tweets-im-zdf-wieder-auftauchten",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "wie-meine-tweets-im-zdf-wieder-auftauchten",
				"stem": "index",
				"path": "wie-meine-tweets-im-zdf-wieder-auftauchten/index.md"
			},
			"requirePath": "wie-meine-tweets-im-zdf-wieder-auftauchten/index.md",
			"path": "/wie-meine-tweets-im-zdf-wieder-auftauchten/",
			"data": {
				"title": "Wie meine Tweets im ZDF wieder auftauchten",
				"date": "2011-12-02 13:15:56 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "wie-viel-wahrheit-steckt-in-dackelkrieg",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "wie-viel-wahrheit-steckt-in-dackelkrieg",
				"stem": "index",
				"path": "wie-viel-wahrheit-steckt-in-dackelkrieg/index.md"
			},
			"requirePath": "wie-viel-wahrheit-steckt-in-dackelkrieg/index.md",
			"path": "/wie-viel-wahrheit-steckt-in-dackelkrieg/",
			"data": {
				"title": "Wie viel Wahrheit steckt in DACKELKRIEG?",
				"date": "2012-12-22 00:00:00 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "wohnungssuche-in-berlin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "wohnungssuche-in-berlin",
				"stem": "index",
				"path": "wohnungssuche-in-berlin/index.md"
			},
			"requirePath": "wohnungssuche-in-berlin/index.md",
			"path": "/wohnungssuche-in-berlin/",
			"data": {
				"title": "Wohnungssuche in Berlin",
				"date": "2011-08-22 10:50:32 +0000",
				"tags": null,
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "zwischen-frustration-und-freiheit",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "zwischen-frustration-und-freiheit",
				"stem": "index",
				"path": "zwischen-frustration-und-freiheit/index.md"
			},
			"requirePath": "zwischen-frustration-und-freiheit/index.md",
			"path": "/zwischen-frustration-und-freiheit/",
			"data": {
				"title": "Zwischen Frustration und Freiheit",
				"date": "2011-08-04 15:52:39 +0000",
				"tags": null,
				"layout": "post"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0